import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WhyTraainBanks = () => {
  const capabilities = [
    'Communicate with clarity, accuracy, and warmth',
    'Reduce errors and misunderstandings',
    'De-escalate frustrated customers and members',
    'Improve cross-sell and referral conversations',
    'Strengthen phone, digital, and in-branch communication',
    'Maintain consistency across locations',
    'Reduce manager coaching hours',
    'Accelerate early-career employee readiness'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Modern Enablement for
            <br />
            <span className="text-cyan-400">Modern Financial Services</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Traain equips banking teams with structured training, realistic practice, and performance visibility — without adding operational complexity.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">With Traain, teams:</p>
          <div className="grid md:grid-cols-2 gap-4">
            {capabilities.map((capability, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{capability}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-2xl font-bold text-white mb-2">
              Traain isn't just training.
            </p>
            <p className="text-xl text-cyan-400">
              It's a performance enablement system designed for financial services leaders.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraainBanks;